module.exports = new __parcel__URL__("unmapped.d0b998cd.png").toString();